module.exports = __webpack_public_path__ + "img/Jump Casting10.055da40e.jpg";